<div class="hpanel gs-widget-cardmargin-bottom-5">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <ul class="profile-list">
          <ng-container *ngFor="let item of peopelData | slice:0:3; let i=index">
            <app-common-profile-info>
              <ng-container headline1>{{item.firstname}}</ng-container>
              <ng-container headline2>{{item.firstname}}</ng-container>
              <ng-container btn>
                <button class="btn-primary btn btn-xs"  (click)="connect(item)">
                <!-- <ng-icon name="tablerPlus" aria-hidden="true" (click)="connect(item)"></ng-icon>  -->
                Connect   
              </button>
            </ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right;" *ngIf="peopelData.length > 3">
          <u><a >...More</a></u>
        </p> -->
        <button class="gs-743-more-btn" type="button" *ngIf="peopelData?.length > 0">
          View more →
        </button>
      </div>
    </div>
  </div>
</div>
